module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAPNJREFUeF7tmrERwkAMBE8JPUBxtAERARG0QXHQA4nIn4dhhsjedQXW6VYvn78CfwpefxRAB8AVEAG4ARyCUwS6e5PknGSfZLtwlzyS3JKcquo51vJJgEuSw8ILH1//WlXHXwW4r6DzY62PqtopwKCACMw4xw/BlQ2/r+W4CZK6PatVB+gAuAIiADeAn8MiIAJwBUQAboD5KYD/HO5uM0EzweXH4X+FongE2D9GSEejixCp22aCEwVEQATgCogA3ACGoiIgAnAFRMArMhMFzAS7vSdID0XNBNGXpUmrgXsAqdtmgmaC7wo4A5wBcAVEAG6AvAAzc2ZBquXWIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public-resource/components/FixHeader/icon-menu.png
// module id = +Sa6
// module chunks = 0